<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    width=900
    placement="right"
    :closable="true"
    @ok="handleOk"
    @close="close"
    :visible="visible"
    style="height: calc(100%);overflow: auto;padding-bottom: 53px;">


      <a-spin :spinning="confirmLoading" > 
        <a-form>
          <a-form-item :label="$t('platformCollection.owned_permissions')">
            <a-tree
              checkable
              :treeData="menuTree"
              @expand="onExpand"
              @select="onTreeNodeSelect"
              @check="onCheck"
              v-model="checkedKeys"
              show-icon
              :selectedKeys="selectedKeys"
              :expandedKeys="expandedKeysss"
              :checkStrictly="false">
              <a-icon slot="api" type="api" style="color:red"/>
              <a-icon slot="tag" type="control" style="color:green"/>
              <span slot="hasDatarule" slot-scope="{slotTitle,ruleFlag}">
                {{ slotTitle }}<a-icon v-if="ruleFlag" type="align-left" style="margin-left:5px;color: red;"></a-icon>
              </span>
            </a-tree>
          </a-form-item>
        </a-form>
      </a-spin>


      <div class="drawer-bootom-button">
        <!-- <a-dropdown style="float: left" :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('platformCollection.parent_child_association') }}</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('platformCollection.cancel_association') }}</a-menu-item>
            <a-menu-item key="3" @click="checkALL">{{ $t('platformCollection.select_all') }}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{ $t('platformCollection.cancel_select_all') }}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{ $t('platformCollection.expand_all') }}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{ $t('platformCollection.collapse_all') }}</a-menu-item>
          </a-menu>
          <a-button>
            {{ $t('platformCollection.tree_operations') }} <a-icon type="up" />
          </a-button>
        </a-dropdown> -->
        <a-popconfirm :title="$t('platformCollection.confirm_abandon_edit')" @confirm="close" :okText="$t('platformCollection.confirm')" :cancelText="$t('platformCollection.cancel')">
          <a-button style="margin-right: .8rem">{{ $t('platformCollection.cancel') }}</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary" :loading="loading">{{ $t('platformCollection.submit') }}</a-button>
      </div>
    <!-- <role-datarule-modal ref="datarule"></role-datarule-modal> -->

  </a-drawer>

</template>
<script>
  // import RoleDataruleModal from './RoleDataruleModal.vue'

  export default {
    name: "RoleModal",
    components:{
      // RoleDataruleModal
    },
    props: {
      menuTree: {
        default: Array,
        default: [],
      }
    },
    data(){
      return {
        roleId:"",
        treeData: [],
        defaultCheckedKeys:[],
        checkedKeys:[],
        halfCheckedKeys: [],
        expandedKeysss:[],
        allTreeKeys:[],
        autoExpandParent: true,
        checkStrictly: true,
        title:"",
        visible: false,
        loading: false,
        confirmLoading: false,
        selectedKeys:[]
      }
    },
    methods: {
      onContextMenuClick(treeKey, menuKey) {
        console.log(`treeKey: ${treeKey}, menuKey: ${menuKey}`);
      },
      onTreeNodeSelect(id){
        // if(id && id.length>0){
        //   this.selectedKeys = id
        // }
        // this.$refs.datarule.show(this.selectedKeys[0],this.roleId)
      },
      onCheck (o, e) {
        this.halfCheckedKeys = e.halfCheckedKeys;
        // if(this.checkStrictly){
        //   this.checkedKeys = o.checked;
        // }else{
        //   this.checkedKeys = o
        // }
      },
      show(roleId){
        this.roleId = roleId
        this.open()
      },
      openLoading () {
          this.confirmLoading = true;
      },
      closeLoading () {
        this.confirmLoading = false;
      },
      open () {
        this.visible = true;
        this.title = this.$t('platformCollection.role_permission_config');
      },
      close () {
        this.reset()
        this.$emit('close');
        this.visible = false;
      },
      setChecked (permissions) {
        this.checkedKeys=permissions.filter(item=>(item.menuType===2||(item.menuType===1 &&item.childrenCount<=0))).map(item=>item.menuId).map(String);
        this.halfCheckedKeys=permissions.filter(item=>item.menuType===1&&item.childrenCount>0).map(item=>item.menuId).map(String);
      },
      onExpand(expandedKeys){
        this.expandedKeysss = expandedKeys;
        this.autoExpandParent = false
      },
      reset () {
        this.expandedKeysss = []
        this.checkedKeys = []
        this.halfCheckedKeys = []
        this.defaultCheckedKeys = []
        this.loading = false
      },
      expandAll () {
        this.expandedKeysss = this.allTreeKeys
      },
      closeAll () {
        this.expandedKeysss = []
      },
      checkALL () {
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if(v==1){
          this.checkStrictly = false
        }else if(v==2){
          this.checkStrictly = true
        }
      },
      handleCancel () {
        this.close()
      },
      handleOk () {
        const checked = [ ...this.checkedKeys, ...this.halfCheckedKeys ];
        this.$emit('ok', checked);
      },
    },
  watch: {
  }
  }

</script>
<style lang="less" scoped>
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>